import Label from 'semantic-ui-react/dist/es/elements/Label';
import './Label.css';

export default Label;
